module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"reported_post":"我舉報/屏蔽的帖子"}}')
  delete Component.options._Ctor
}
